<div
  [id]="editorId"
  class="unlayer-editor"
  [style.min-height]="minHeight"
></div>
